<template>
    <el-dialog
        v-if="isDialogVisible"
        :visible="isDialogVisible"
        @close="onFormClose"
        :title="title"
        :destroy-on-close="true"
    >
        <loading v-if="isFormBusy"></loading>
        <form-wrapper
            v-show="!isFormBusy"
            :get-form-url="getFormUrl"
            @initialized="this.onFormInitialized"
            @initialization-error="this.onFormInitializationError"
            @created="onCreated"
        ></form-wrapper>
    </el-dialog>
</template>

<script>
  import eventBus from "../../../../event-bus";
  import FormWrapper from "./form-wrapper";
  import Loading from "../../../loading";


  export default {
    components: {
      FormWrapper,
      Loading,
    },

    data() {
      return {
        getFormUrl: null,
        isFormBusy: true,
        title: null,
        itemsCreated: 0,
      };
    },

    computed: {
      isDialogVisible() {
        return !_.isNull(this.getFormUrl);
      }
    },

    methods: {
      /**
       * @param {*} payload
       */
      showForm({url}) {
        this.title = 'ADD NEW GROUP ITEM';
        this.getFormUrl = url;
      },

      /**
       * @return {undefined}
       */
      onFormClose() {
        if (this.itemsCreated > 0) {
          eventBus.$emit('send-list-items-updated');
        }
        this.destroyForm();
      },

      /**
       * @return {undefined}
       */
      onFormInitialized() {
        this.isFormBusy = false;
      },

      /**
       * @return {undefined}
       */
      destroyForm() {
        this.itemsCreated = 0;
        this.isFormBusy = true;
        this.getFormUrl = null;
      },

      /**
       * @param {Object} value
       */
      onFormInitializationError({message}) {
        this.destroyForm();
        message && this.$message.error(message);
      },

      /**
       * @return {undefined}
       */
      onCreated() {
        this.itemsCreated++;
      }
    },

    created() {
      eventBus.$on('show-add-send-list-conversation-item-modal-form', this.showForm);
    },

    beforeDestroy() {
      eventBus.$off('show-add-send-list-conversation-item-modal-form', this.showForm);
    },
  }
</script>

